import Home from './home/Home';
import HomeJack from './home/HomeJack';
import GalleryList from './ex-pub-gallery/GalleryList';
import About from './about/About';
import Contact from './about/Contact';
import BlogLanding from './blog/BlogLanding';
import NoMatch from './NoMatch';
import PhotoLanding from './PhotoLanding';
import FilmLanding from './FilmLanding';
import FineArtLanding from './FineArtLanding';
import PublicationsLanding from './PublicationsLanding';
import SinglePortfolio from './SinglePortfolio';
import SingleFilm from './SingleFilm';
import SinglePublication from './SinglePublication';
import SingleExhibition from './SingleExhibition';
import SingleArticle from './SingleArticle';

export {
  Home,
  HomeJack,
  GalleryList,
  About,
  BlogLanding,
  Contact,
  NoMatch,
  PhotoLanding,
  FilmLanding,
  FineArtLanding,
  PublicationsLanding,
  SinglePortfolio,
  SingleFilm,
  SinglePublication,
  SingleExhibition,
  SingleArticle
};



// WEBPACK FOOTER //
// ./src/pages/index.js